import { SystemAuthorizations } from 'shell/authorizations/system';
import * as yup from 'yup';
import { HeadCell } from 'shell/components/shared/table/types';
import { Numerator } from './types';
import { regexOnlyNumber, alphanumericRegex } from 'shell/constants/regex';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.ProfiloQuery],
  create: [SystemAuthorizations.ProfiloAdd],
  edit: [SystemAuthorizations.ProfiloUpdate],
  delete: [SystemAuthorizations.ProfiloDelete],
});

export const validationSchemaNumeratorsFilter = yup.object({
  numeratorRegisterType: yup.string().nullable().notRequired(),
  year: yup.string().nullable().notRequired().matches(regexOnlyNumber, 'Il campo è numerico'),
  description: yup
    .string()
    .nullable()
    .notRequired()
    .matches(alphanumericRegex, 'Il campo è alfanumerico'),
});

export const headCells: HeadCell<Numerator, keyof Numerator>[] = [
  {
    id: 'numeratorRegisterType',
    label: 'Tipo Registro Numeratore',
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'year',
    label: 'Anno',
  },
  {
    id: 'currentNumerator',
    label: 'Numeratore Attuale',
  },
  {
    id: 'action',
    label: '',
  },
];
